/**
 * Normalize mobile number to international format
 * Default country: India (91)
 */
export function normalizeMobileNumber(mobile, countryCode = "91") {
  if (!mobile) return null;

  const digits = String(mobile).replace(/\D/g, "");

  if (digits.length < 10) return null;

  return digits.startsWith(countryCode)
    ? digits
    : `${countryCode}${digits}`;
}

// All voter sends share one browser tab.
export const WHATSAPP_TAB_NAME = "smartSearchWhatsApp";

/**
 * Open WhatsApp chat with prefilled message.
 * Returns true if the tab was opened/reused, false if it was blocked.
 * NOTE: the browser can only *prefill* the message — the user still has to
 * press Send in WhatsApp. There is no way to click it from here.
 */
export function openWhatsApp({
  mobile,
  message,
  countryCode = "91",
}) {
  const phone = normalizeMobileNumber(mobile, countryCode);

  if (!phone) {
    alert("Invalid or missing mobile number");
    return false;
  }

  if (!message) {
    alert("WhatsApp message is empty");
    return false;
  }

  const encodedMessage = encodeURIComponent(message.trim());

  const isMobile =
    /Android|iPhone|iPad|iPod/i.test(navigator.userAgent);

  const url = isMobile
    ? `https://wa.me/${phone}?text=${encodedMessage}`
    : `https://web.whatsapp.com/send?phone=${phone}&text=${encodedMessage}`;

  // ✅ NAMED TAB: if a WhatsApp tab from this app is already open, Chrome
  // reuses and focuses it instead of piling up a new tab per voter.
  // (noopener is deliberately NOT passed — it breaks the named-tab reuse.)
  const win = window.open(url, WHATSAPP_TAB_NAME);

  if (!win) {
    alert(
      "Chrome blocked the WhatsApp tab.\nAllow pop-ups for this site and try again."
    );
    return false;
  }

  try {
    win.focus();
  } catch (e) {
    // cross-origin focus can throw once WhatsApp Web has loaded — harmless
  }

  return true;
}